
export const sampleSetsSetter = (state, action) => {
  const { payload } = action;

  state.sampleSets.raw = payload.raw;
  state.sampleSets.error = payload.error;
};

export const sampleSetsGetter = (state, action) => { };